Namespace 'Monitoring.Models.SocialContents'

class Monitoring.Models.SocialContents.InstagramBusinessDiscoveryMedia
  constructor: (data) ->
    @data = data

  getText: ->
    @data.text

  getCreatedAt: ->
    @data.created_at

  getParentId: ->
    @data.parent_id

  getContentId: ->
    @data.content_id

  getIsBrandContent: ->
    @data.is_brand_content

  getPermalink: ->
    @data.permalink

  getMediaType: ->
    @data.media_type

  getMediaUrl: ->
    @data.media_url

  getSubType: ->
    @data.sub_type

  getOrigin: ->
    @data.origin
